<template>
  <vf-breadcrumbs
    v-if="product"
    v-style:display="{
      sm: $feature.breadcrumbVisibilityOnPDP?.sm ? 'flex' : 'none',
      md: $feature.breadcrumbVisibilityOnPDP?.md ? 'flex' : 'none',
      lg: $feature.breadcrumbVisibilityOnPDP?.lg ? 'flex' : 'none',
    }"
    :class="[brandClasses.breadcrumbs, { '!hidden': hideBreadcrumbs }]"
    :items="product.breadcrumbs || []"
    :last-step="showBreadcrumbsLastStep ? { label: product.name } : undefined"
    :max-items="breadcrumbsMaxItems"
  />
</template>

<script setup lang="ts">
const { brandClasses, breadcrumbsMaxItems, hideBreadcrumbs, showBreadcrumbsLastStep } = useAppConfig().pages.pdp
const { product } = usePdp()
</script>
